import { useQueryClient } from '@tanstack/react-query';

import type { CommonMutationOptions } from '../../../common/types/Common';
import type { MembershipDetails } from '../../entityTypes';
import { getMembershipDetailsQueryKey } from '../MembershipDetailsEntityProvider';

// Common mutation options that trigger a refetch of the MembershipDetails entity.
export const useRefetchMembershipDetailsMutationOptions = (
    membership: MembershipDetails | null,
): CommonMutationOptions => {
    const queryClient = useQueryClient();
    const membershipDetailsQueryKey = getMembershipDetailsQueryKey({
        membershipId: membership?.id,
    });

    return {
        onMutate: async () => {
            await queryClient.cancelQueries({
                queryKey: [membershipDetailsQueryKey],
                exact: true,
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: [membershipDetailsQueryKey],
                exact: true,
            });
        },
        onSettled: () => {},
    };
};
